import { Observable } from "rxjs"

import { STUDIO_DOWNLOAD_IMAGE_REQUEST } from "../actions/action-types"
import { downloadFile } from "../config/util-functions"
import { getMapImage } from "../api/map-api"
import { mapRequestError } from "./default-epics/epic-utils"
import {
    studioDownloadImageErrorResponse,
    studioDownloadImageResponse
} from "../actions/studio-actions"
import { unauthenticated } from "../actions/authentication-actions"

export const studioImageRequestEpic = (action$, { getState }) =>
    action$
        .ofType(STUDIO_DOWNLOAD_IMAGE_REQUEST)
        .mergeMap(({ id, queryParams }) => {
            const { token } = getState().authentication
            return getMapImage(token, id, queryParams)
                .map(({ response }) => {
                    const fileName = `map_${id}.png`
                    downloadFile(response, fileName)

                    return studioDownloadImageResponse()
                })
                .catch(error =>
                    Observable.of(
                        mapRequestError(
                            error,
                            unauthenticated,
                            studioDownloadImageErrorResponse,
                            id
                        )
                    )
                )
        })
